'use client';

import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Image from 'next/image';
import { getRunTimeEnv } from '../../util/getEnvVariable';
import { BLUR_DATA_URL } from '../../util/imageConstants';
import { getIconSize } from './utterance.util';

/**
 * @name UtteranceIcon
 * @param {object} props - Strapi Data
 * @returns {JSX.Element} - Renders Next js Image component
 */
const UtteranceIcon = props => {
  const theme = useTheme();
  const sm = useMediaQuery(theme.breakpoints.down('sm'));
  const clientSideEnv = getRunTimeEnv();

  return (
    <Image
      placeholder={props.tileIcon ? 'empty' : 'blur'}
      blurDataURL={BLUR_DATA_URL}
      width={getIconSize(props?.tileIcon, sm)}
      height={getIconSize(props?.tileIcon, sm)}
      src={
        props?.isHovered
          ? `${clientSideEnv.NEXT_PUBLIC_STRAPI_SERVER || process.env.NEXT_PUBLIC_STRAPI_SERVER}${props?.hoverIcon?.data?.attributes?.url}`
          : `${clientSideEnv.NEXT_PUBLIC_STRAPI_SERVER || process.env.NEXT_PUBLIC_STRAPI_SERVER}${props?.icon?.data?.attributes?.url}`
      }
      alt={
        props?.isHovered
          ? props?.hoverIcon?.data?.attributes?.alternativeText
          : props?.icon?.data?.attributes?.alternativeText
      }
      style={{
        objectFit: 'cover',
        transition: 'opcacity 0.3s ease',
        transitionBehavior: 'allow-discrete',
      }}
      quality={100}
    ></Image>
  );
};

UtteranceIcon.displayName = 'UtteranceIcon';
export default UtteranceIcon;
